<template>
  <div class="chart-widget">
    <v-row class="select-row">
      <v-col cols="12" class="select-col">
        <v-select
          v-model="type"
          :items="types"
          label="Tipo"
          prepend-inner-icon="mdi-format-list-bulleted-type"
          filled
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="chart-row">
      <SimplePie
        v-if="chart"
        :value="chart"
        id="historic-catalog"
      />
    </v-row>
  </div>
</template>

<script>
import SimplePie from '@/components/charts/apex/SimplePie'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { SimplePie },
  mixins: [ appdata, utils ],
  props: {
    customData: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    types: [
      {
        text: 'Categorias',
        value: 'categories'
      },
      {
        text: 'Sub-Categorias',
        value: 'sub-categories'
      }
    ],
    type: 'sub-categories'
  }),
  computed: {
    data () {
      return (this.customData ? (this.socketInfo.custom_data ? this.socketInfo.custom_data.catalog : []) : (this.get_data ? this.get_data.catalog : []))
    },
    chart () {
      switch (this.type) {
        case 'categories':
          return this.catChart()
        case 'sub-categories':
          return this.subcatChart()
      }
      return []
    }
  },
  methods: {
    catChart () {
      let chart = []
      let categories = this.get_data.categories || []
      const data = categories.filter((el) => el.parent === 0)
      data.forEach(function (obj) {
        let output = this.data.filter((el) => el.parent_cat === obj.id)
        if (output.length > 0) chart.push({ title: obj.name, value: output.length })
      }.bind(this))
      let sorted = chart.sort(function (a, b) {
        var x = a.value; var y = b.value
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
      var top10 = sorted.slice(0, 10)
      var filtered = top10.filter(e => e != null)
      return filtered
    },
    subcatChart () {
      let chart = []
      let subcategories = this.get_data.categories || []
      const data = subcategories.filter((el) => el.parent !== 0)
      data.forEach(function (obj) {
        let output = this.data.filter((el) => el.cat === obj.id)
        if (output.length > 0) chart.push({ title: obj.name, value: output.length })
      }.bind(this))
      let sorted = chart.sort(function (a, b) {
        var x = a.value; var y = b.value
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
      var top10 = sorted.slice(0, 10)
      var filtered = top10.filter(e => e != null)
      return filtered
    }
  }
}
</script>
